export default "__VITE_ASSET__BFxDGSXu__"